import React, { ReactNode, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ErrorBoundary } from '../../../../components/common/ErrorBoundary'
import { useAppTranslation } from '../../../../hooks/useAppTranslation'
import { useCurrentSociety } from '../../../../hooks/useCurrentSociety'
import { ViewBase } from '../../../../components/common/ViewBase'
import { FacilitiesList } from '../../../../components/society/FacilitiesList'
import { reverseUrl } from '../../../../navigation/reverseUrl'
import { ButtonVariant } from '../../../../components/common/Button'
import { IconChoices } from '../../../../components/common/Icon'
import { BookingsList } from '../../../../components/society/BookingsList'
import { isUserAdminInSociety } from '../../../../helpers/society'
import { useDocumentTitle } from '../../../../hooks/useDocumentTitle'
import { reverseDocumentTitle } from '../../../../navigation/reverseDocumentTitle'
import { useAuth } from '../../../../hooks/useAuth'

export enum ActiveTab {
  FACILITIES = 0,
  BOOKINGS = 1,
}

export const FacilitiesView = (): ReactNode => {
  const { translate } = useAppTranslation()
  const { userId } = useAuth()
  const navigate = useNavigate()
  const { society } = useCurrentSociety()
  useDocumentTitle(
    reverseDocumentTitle('society:facilities', {
      '{{ societyName }}': society?.name,
    })
  )
  const [activeTab, setActiveTab] = useState<ActiveTab>(ActiveTab.FACILITIES)
  const tabs = [
    {
      title: translate('facilitiesView.tabBar.newBooking'),
    },
    {
      title: translate('facilitiesView.tabBar.myBookings'),
    },
  ]

  const isAdmin = isUserAdminInSociety(society, userId as string)

  const navigateToCreateUpdateFacilityView = (): void => {
    navigate(
      reverseUrl('society:facilities-create', {
        id: society?._id,
      })
    )
  }

  return (
    <ErrorBoundary>
      <ViewBase
        title={translate('facilitiesView.title')}
        tabBar={{ tabs, setActiveTab, activeTab }}
        buttons={[
          ...(isAdmin
            ? [
                {
                  label: translate('facilitiesView.buttons.create'),
                  variant: ButtonVariant.PRIMARY,
                  icon: IconChoices.PLUS_SIGN,
                  onClick: navigateToCreateUpdateFacilityView,
                },
              ]
            : []),
        ]}
      >
        {activeTab === ActiveTab.FACILITIES ? (
          <FacilitiesList />
        ) : (
          <BookingsList />
        )}
      </ViewBase>
    </ErrorBoundary>
  )
}
